/**
 * 1 つの KUMODeck アカウントの日本語（en.oneAccount.ts と同じキーを全部持つ。漏れは typecheck で落ちる）。表記の決め事は ja.ts の冒頭と同じ。
 */
import type { enOneAccount } from './en.oneAccount';

type OneAccountMessages = { [K in keyof typeof enOneAccount]: string };

export const jaOneAccount: OneAccountMessages = {
  'oneAccount.signIn.title': 'ログイン',
  'oneAccount.signIn.lead': '{product} のアカウントでログインします。作るときも、ログインして使うアプリでも、同じアカウントです。',
  'oneAccount.signIn.button': 'ログインへ進む',
  'oneAccount.signIn.busy': '開いています…',
  'oneAccount.signIn.storageBlocked': 'ブラウザがログインの途中の情報を保存させませんでした。プライベートブラウズを止めるか、このページのサイトデータを許可してから、もう一度お試しください。',
  'oneAccount.signIn.oldPasskeyTitle': '前にこのページでパスキーを保存しましたか？',
  'oneAccount.signIn.oldPasskeyLead': 'しばらくはここで使えます。',
  'oneAccount.callback.working': 'ログインしています…',
  'oneAccount.callback.failedTitle': 'ログインが終わりませんでした',
  'oneAccount.callback.expired': 'ログインの途中の手順の期限が切れたか、もう使われています。もう一度ログインしてください。',
  'oneAccount.callback.otherTab': '別のタブやウィンドウでログインを始めたか、このページを再読み込みしました。ここでもう一度ログインしてください。',
  'oneAccount.callback.again': 'もう一度ログイン',
  'oneAccount.mode.label': '表示の切り替え',
  'oneAccount.mode.player': 'プレイヤー',
  'oneAccount.mode.creator': 'クリエイター',
  'oneAccount.oldPasskey.title': 'パスキーをもう一度登録してください',
  'oneAccount.oldPasskey.body':
    'このページ用に保存したパスキーでログインしました。ログインはアカウントのページで行うようになり、このパスキーはそこでは使えません。アカウントのページで新しいパスキーを 1 回登録してください。',
  'oneAccount.oldPasskey.open': 'アカウントのページを開く',
  'oneAccount.oldPasskey.later': 'あとで',
  'oneAccount.openAccountPage': 'アカウントのページを開く',
  'player.tabs.label': 'アカウント',
  'player.tabs.games': 'ゲーム',
  'player.tabs.profile': 'プロフィール',
  'player.tabs.signIn': 'ログイン',
  'player.games.next': '{product} で作ったゲームを開いて「{product} でログイン」を押してください。このアカウントで入れます。',
  'player.title': 'あなたのアカウント',
  'player.lead': '{product} のアカウントで遊んでいるゲーム。',
  'player.signInNeeded': 'アカウントを見るには、もう一度ログインしてください。',
  'player.email': 'メール',
  'player.noEmail': 'メールアドレスはまだありません',
  'player.name.label': '表示名',
  'player.name.hint': 'ゲームがこの名前を表示できます。32 文字まで。何も入れなければ名前を出しません。',
  'player.name.save': '名前を保存',
  'player.name.saved': '保存しました。',
  'player.games.title': 'つないだゲーム',
  'player.games.empty': 'このアカウントでログインしたゲームはまだありません。',
  'player.games.testVersion': 'テスト版',
  'player.games.lastSignIn': '最後のログイン {date}',
  'player.games.notYet': 'まだログインしていません',
  'player.games.play': '遊ぶ',
  'player.games.playTest': 'テスト版で遊ぶ',
  'player.games.hide': '一覧から外す',
  'player.games.hideHint': '「一覧から外す」はここに出さなくするだけで、次にそのゲームにログインするとまた出ます。「外す」はすべての端末でそのゲームからログアウトします。',
  'player.games.disconnect': '外す',
  'player.games.disconnectConfirm': '{game} を外しますか？ すべての端末でこのゲームからログアウトします。ほかのゲームはそのままです。',
  'player.methods.title': 'ログインの方法',
  'player.methods.lead': 'どれでもログインできます。',
  'player.methods.email': 'メールのリンクかコード',
  'player.methods.remove': '外す',
  'player.methods.removeConfirm': '{method} を外しますか？ これではログインできなくなります。',
  'player.methods.add': 'ログインの方法を足す',
  'player.methods.addHint': 'アカウントのページが開きます。終わったら、このタブに戻ってください。',
  'player.delete.title': 'アカウントの削除',
  'player.delete.lead': 'アカウントとゲームとのつながりが消え、すべてのゲームからログアウトします。元に戻せません。',
  'player.delete.button': 'アカウントを削除',
  'player.delete.confirm': 'アカウントを削除しますか？ 元に戻せません。',
  'player.delete.creatorLead': 'このアカウントで作ってもいるので、ここでは削除できません。先に「クリエイター」で作り手のアカウントを閉じてください。残高を確かめてから消します。',
  'player.delete.creatorButton': '作り手のアカウントの設定を開く',
  'player.delete.closedLead': '作り手のアカウントはもう閉じてあります。このアカウントも削除したいときは、お問い合わせください。',
  'player.notYetHere': 'ここではまだ変えられません。アカウントのページで変えてください。',
  'error.last_method': 'ログインの方法がこれだけなので外せません。先にほかの方法を足してください。',
  'error.creator_account':
    'このアカウントで作ってもいるので、ここでは削除できません。作るのをやめるには、先に「クリエイター」に切り替えて、アカウントのページで作り手のアカウントを閉じてください。',
  'creatorStart.title': '作り始める',
  'creatorStart.leadRequired': '作る機能は今は招待制です。受け取った招待コードを入れてください。',
  'creatorStart.leadOptional': '招待コードがあれば入れてください。空のままでも始められます。',
  'creatorStart.submit': '作り始める',
  'creatorStart.busy': '始めています…',
  'creatorStart.emailRequired':
    'このアカウントにはまだメールアドレスがありません。作るには、領収書やセキュリティのお知らせの宛先が要ります。アカウントのページでメールを足してから、ここに戻ってもう一度ボタンを押してください。',
  'creatorStart.emailInUse':
    '{email} はほかの作り手のアカウントがもう使っていて、自動ではつなげませんでした。今までのプロジェクトを開くには、ログアウトしてから、前に作っていたときと同じ方法（Google・GitHub・メールとパスワードなど）でログインし、そこでアカウントをつないでください。',
  'creatorStart.signOut': 'ログアウト',
  'creatorStart.already': 'このアカウントはもう作る機能を使えます。もう一度ログインすると「クリエイター」が開きます。'
};
